import { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { listarTudo } from "../../services/api";

const TIPOS = { BASICO: "Básico", PROFISSIONAL: "Profissional", EMPRESARIAL: "Empresarial" };

const PlanosDeUso = () => {
  const { isDiretor } = useAuth();
  const [planos, setPlanos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");

  useEffect(() => {
    // Só busca os planos se o usuário realmente pode ver esta tela — evita
    // disparar a chamada para quem vai receber a tela de "acesso restrito"
    // de qualquer forma.
    if (!isDiretor) {
      setLoading(false);
      return;
    }
    listarTudo("/configuracoes/planos/")
      .then((res) => setPlanos(res.data))
      .catch(() => setErro("Erro ao carregar planos."))
      .finally(() => setLoading(false));
  }, [isDiretor]);

  if (!isDiretor) {
    return (
      <div className="p-6 bg-white rounded-xl shadow text-red-600">
        Acesso restrito a Diretores e Proprietários.
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-bold text-green-800">Planos de Uso</h1>

      {erro && <div className="p-3 text-red-700 bg-red-50 border border-red-200 rounded-lg text-sm">{erro}</div>}

      {loading ? (
        <p className="text-gray-500">Carregando...</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {planos.map((p) => (
            <div key={p.id} className="bg-white rounded-xl shadow p-5 border border-green-100">
              <span className="text-xs font-semibold px-2 py-1 bg-green-100 text-green-800 rounded-full">
                {TIPOS[p.tipo] || p.tipo}
              </span>
              <h2 className="text-lg font-bold text-green-900 mt-3">{p.nome}</h2>
              {p.descricao && <p className="text-sm text-gray-500 mt-1">{p.descricao}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PlanosDeUso;
